import * as Sentry from "@sentry/react";
import React from "react";
import { withTranslation } from "react-i18next";
import { reloadOnChunkLoadError } from "../chunk-reload";
import SvgIcon from "../parts/SvgIcon";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.setHasError = this.setHasError.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    if (reloadOnChunkLoadError(error)) return;
    Sentry.withScope((scope) => {
      scope.setTag("error_boundary", true);
      scope.setContext("react_error_info", {
        componentStack: info.componentStack,
      });
      Sentry.captureException(error);
    });
  }

  componentDidMount() {
    window.addEventListener("popstate", this.setHasError, false);
  }

  componentWillUnmount() {
    window.removeEventListener("popstate", this.setHasError, false);
  }

  setHasError(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.state.hasError) {
      this.setState({ hasError: false });
      location.reload();
    }
  }

  render() {
    const { t } = this.props;
    if (this.state.hasError && this.props.fallback) {
      return this.props.fallback;
    }
    if (this.state.hasError && !this.props.fallback) {
      return (
        <div id="error-wrapper" className="error-boundary">
          <SvgIcon
            src={"/img/new-icons/msb-logo-not-extended.svg"}
            noFilterOnLight={true}
          />
          <h1>{t("errorBoundary.title")}</h1>
          <p className="p2">{t("errorBoundary.description")} </p>
          <a style={{ color: "#04A1E1" }} href="mailto:info@mystrengthbook.com">
            info@mystrengthbook.com
          </a>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
            data-button-type="primary"
          >
            {t("errorBoundary.reload")}
          </button>
        </div>
      );
    }

    return this.props.children || null;
  }
}

export default withTranslation("auth")(ErrorBoundary);
